import React, { HtmlHTMLAttributes, RefObject, useEffect, useState } from 'react';
import { CommandBarButton, Dropdown, IBasePicker, IBasePickerSuggestionsProps, IconButton, IDropdownOption, IPersonaProps, IRenderFunction, ITag, Label, mergeStyleSets, NormalPeoplePicker, TagPicker, TextField, ValidationState } from '@fluentui/react';
import CircleLoader from '../../../Loader/CircleLoader/CircleLoader';
import { IAoo, IField, ISendMailFields, IUor } from '../../../../shared/interfaces';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import pecmailService from '../../../../services/pecmail.service';
import { RootState } from '../../../../store';
import { useSelector } from 'react-redux';
import Utilities from '../../../../shared/Utilities/utilities';
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css"; // Add css for snow theme
import "../../../../assets/styles/quill-custom.css"; // Add css for snow theme




const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',

    }
});

const emailRegex = Utilities.GetRegexIndirizziEmailSeparatiDaPuntoEVirgola();


export interface SendMailFormProps {
    loading?: boolean
    extraCssClass?: string
    sendMailFields: ISendMailFields
    onInputChangedHandler: (newField: IField) => void

}

const SendMailForm: React.FunctionComponent<SendMailFormProps> = (props) => {

    let loading = props.loading !== undefined ? props.loading : false;

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);


    const peoplePickerRefTO = React.createRef<IBasePicker<IPersonaProps>>();
    const peoplePickerRefCC = React.createRef<IBasePicker<IPersonaProps>>();
    peoplePickerRefTO.current?.focus();


    const [peopleList, setPeopleList] = useState<IPersonaProps[]>([]);

    const theme = 'snow';
    // const theme = 'bubble';

    const modules = {
        toolbar: [
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline'], 
                [{ 'color': [] }, { 'background': [] }],     
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
        ],
    };


    const { quill, quillRef } = useQuill({ theme, modules });
    const [bodyValue, setBodyValue] = useState<string>()


    useEffect(() => {
        if (props.sendMailFields.from.internalValue && currentAoo && currentUor) {
            getMailboxContacts(currentAoo, currentUor, props.sendMailFields.from.internalValue);
        }
    }, [props.sendMailFields.from.internalValue]);

    useEffect(() => {
        if (quill) {
            quill.on('text-change', function (delta, source) {
                let html = quill.root.innerHTML;
                setBodyValue(quill.root.innerHTML);
            })
        }
    }, [quill]);

    useEffect(() => {
        if (bodyValue) {
            inputChanged({ ...props.sendMailFields.body, internalValue: bodyValue });
        }
    }, [bodyValue]);

    const inputChanged = (newField: IField) => {

        props.onInputChangedHandler({ ...newField, valid: AppUtilities.checkFieldValidity(newField), touched: true })
    }

    const onChangeTextFieldValue = (field, newValue?: string) => {

        if (field.maxLength && field.maxLength > 0) {
            if (newValue && newValue.length <= field.maxLength) {
                inputChanged({ ...field, internalValue: newValue });

            }
            else {
                inputChanged({ ...field });
            }
        }
        else inputChanged({ ...field, internalValue: newValue });

        

    }

    let onDropDownSelectChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        inputChanged({ ...props.sendMailFields.from, internalValue: option?.key })
        if (currentAoo && currentUor && option && option)
            getMailboxContacts(currentAoo, currentUor, option.key.toString());
    }

    let onCleanDropdownButton = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        inputChanged({ ...props.sendMailFields.from, internalValue: null });
    }

    const onRenderSelectdOptionDropDown = (options: IDropdownOption<any>[] | undefined): JSX.Element => {
        const option = options![0];

        return (
            <div>
                <span>{option.text}
                    <IconButton
                        iconProps={{ iconName: 'Cancel' }}
                        styles={{ root: { height: 20, width: 20, verticalAlign: 'text-top' } }}
                        onClick={onCleanDropdownButton}
                    />
                </span>
            </div>
        );
    };




    const getMailboxContacts = (currentAoo: IAoo, currentUor: IUor, mailbox: string) => {
        let personas: IPersonaProps[] = [];

        pecmailService.getMailboxContacts(currentAoo.id, currentUor.id!, mailbox)
            .then(mailboxContacts => {
                mailboxContacts
                    .filter(item => item.Pec || item.Email)
                    .forEach(item => {

                        let address;
                        if (item.Pec) {
                            address = item.Pec;
                        }
                        else if (item.Email) {
                            address = item.Email;

                        }
                        personas.push(
                            {
                                key: address,
                                imageInitials: Utilities.GetInizialiFromUserName(item.Titolo),
                                text: item.Titolo,
                                secondaryText: address,
                                hidePersonaDetails: false,

                            }
                        );
                    });
                setPeopleList(personas);
            });
    }


    const peoplePickerSuggestionsProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Risultati recenti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
    };


    const onPeoplePickerFilterChanged = async (
        filterText: string,
        currentPersonas?: IPersonaProps[],
    ): Promise<IPersonaProps[]> => {
        if (filterText) {
            let filteredPersonas = await filterPersonasByText(filterText);

            if (currentPersonas)
                filteredPersonas = removePeoplePickerDuplicates(filteredPersonas, currentPersonas);

            return filteredPersonas;
        } else {
            return [];
        }
    };

    const filterPersonasByText = async (filterText: string): Promise<IPersonaProps[]> => {
        return peopleList.filter(item => doesTextStartWith(item.text as string, filterText) || doesTextStartWith(item.secondaryText as string, filterText));
    };
    const doesTextStartWith = (text: string, filterText: string): boolean => {
        return text.toLowerCase().indexOf(filterText.toLowerCase()) === 0;
    }

    const removePeoplePickerDuplicates = (personas: IPersonaProps[], possibleDupes: IPersonaProps[]) => {
        return personas.filter(persona => possibleDupes.findIndex(el => el.key === persona.key) < 0);
    }

    const onPersonaSelected = (selectedItem: any): IPersonaProps | null => {
        return selectedItem;
    }

    const onRenderNoResultFound = (tagPickerRef: RefObject<IBasePicker<IPersonaProps>>) => {
        return (
            <CommandBarButton iconProps={{ iconName: 'Add' }} styles={{
                root: {
                    height: 30
                }
            }} text="Aggiungi" onClick={() => {
                tagPickerRef!.current?.completeSuggestion(true);
            }} />
        );

    }



    const onPeoplePickerInputPaste = (ev, field: IField) => {

        let destinatariText = ev.clipboardData.getData('text/plain');

        let emailAddress: any[] = [];
        let array;
        let currentValue: any[] = field.internalValue;

        let stopProtagation = false;
        while ((array = emailRegex.exec(destinatariText)) !== null) {
            if (currentValue.findIndex(el => el.key === array[0]) < 0) {
                emailAddress.push({ key: array[0], text: array[0] });
            }
            stopProtagation = true;

        }

        if (stopProtagation) {
            // se nel testo incollato c'� almeno un indirizzo email impedisco il paste e aggiungo gli indirizzi email aggiornando l'internal value
            ev.preventDefault();
            ev.stopPropagation();
        }

        inputChanged({ ...field, internalValue: [...field.internalValue, ...emailAddress] });

    }
    const createGenericPeoplePickerItem = (input: string) => {
        return { key: input, text: input };
    }
    const onValidatePeoplePickerInput = (field: IField, input: string) => {
        let arr: ITag[] = field.internalValue;

        if (input && arr.findIndex(el => el.key === input) < 0 && emailRegex.test(input)) {
            return ValidationState.valid;
        }
        else {
            let newField = { ...field };
            newField.valid = false;
            newField.touched = true;
            inputChanged( newField);
            return ValidationState.invalid
        }

    }
    const onPeoplePickerItemsChange = (field, items?: any[]): void => {
        inputChanged({ ...field, internalValue: items });
    };

    const getTextFromPersonaItem = (persona: IPersonaProps): string => {
        return persona.text as string;
    }







    return (

        <React.Fragment>
            <CircleLoader loaderClass='loader-large' loading={loading} />

            {
                props.sendMailFields.from.options.length > 1 &&
                <div className={classNames.inputWrapper}>
                    <div className={props.sendMailFields.from.touched && !props.sendMailFields.from.valid ? 'field error' : 'field'}>
                        <Label className='field-label' htmlFor={props.sendMailFields.from.internalName} required={props.sendMailFields.from.required}>{props.sendMailFields.from.displayName}</Label>

                        <Dropdown
                            key={props.sendMailFields.from.internalName}
                            disabled={false}
                            placeholder="Seleziona una cassetta"
                            options={props.sendMailFields.from.options as IDropdownOption[]}
                            selectedKey={props.sendMailFields.from.internalValue}
                            onChange={onDropDownSelectChange}
                            onRenderTitle={onRenderSelectdOptionDropDown}
                        />


                        {props.sendMailFields.from.touched && !props.sendMailFields.from.valid && <span className="error-message">Campo obbligatorio</span>}

                    </div >
                </div >
            }
            <div className={classNames.inputWrapper}>
                <div className={props.sendMailFields.to.touched && !props.sendMailFields.to.valid ? 'field error' : 'field'}>
                    <Label className='field-label' htmlFor={props.sendMailFields.to.internalName} required={props.sendMailFields.to.required}>{props.sendMailFields.to.displayName}</Label>




                    <NormalPeoplePicker
                        key={props.sendMailFields.to.internalName}
                        componentRef={peoplePickerRefTO}
                        getTextFromItem={getTextFromPersonaItem}
                        selectedItems={props.sendMailFields.to.internalValue}
                        pickerSuggestionsProps={{
                            ...peoplePickerSuggestionsProps,
                            onRenderNoResultFound: () => onRenderNoResultFound(peoplePickerRefTO)
                        }}
                        onResolveSuggestions={onPeoplePickerFilterChanged}
                        onItemSelected={onPersonaSelected}
                        onChange={(items) => onPeoplePickerItemsChange({ ...props.sendMailFields.to }, items)}
                        inputProps={{ onPaste: (e) => onPeoplePickerInputPaste(e, props.sendMailFields.to) }}
                        onValidateInput={(input) => onValidatePeoplePickerInput(props.sendMailFields.to, input)}
                        createGenericItem={createGenericPeoplePickerItem}


                        className={'ms-PeoplePicker'}

                        resolveDelay={300}
                       
                    />


                    {props.sendMailFields.to.touched && !props.sendMailFields.to.valid && <span className="error-message">Campo obbligatorio, inserire un indirizzo valido o selezionare un contatto dai suggerimenti</span>}
                </div>
            </div>

            <div className={classNames.inputWrapper}>
                <div className={props.sendMailFields.cc.touched && !props.sendMailFields.cc.valid ? 'field error' : 'field'}>
                    <Label className='field-label' htmlFor={props.sendMailFields.cc.internalName} required={props.sendMailFields.cc.required}>{props.sendMailFields.cc.displayName}</Label>

                    <NormalPeoplePicker
                        key={props.sendMailFields.cc.internalName}
                        componentRef={peoplePickerRefCC}
                        getTextFromItem={getTextFromPersonaItem}
                        selectedItems={props.sendMailFields.cc.internalValue}
                        pickerSuggestionsProps={{
                            ...peoplePickerSuggestionsProps,
                            onRenderNoResultFound: () => onRenderNoResultFound(peoplePickerRefCC)
                        }}
                        onResolveSuggestions={onPeoplePickerFilterChanged}
                        onItemSelected={onPersonaSelected}
                        onChange={(items) => onPeoplePickerItemsChange({ ...props.sendMailFields.cc }, items)}
                        inputProps={{ onPaste: (e) => onPeoplePickerInputPaste(e, props.sendMailFields.cc) }}
                        onValidateInput={(input) => onValidatePeoplePickerInput(props.sendMailFields.cc, input)}
                        createGenericItem={createGenericPeoplePickerItem}


                        className={'ms-PeoplePicker'}

                        resolveDelay={300}

                    />


                    {props.sendMailFields.cc.touched && !props.sendMailFields.cc.valid && <span className="error-message">Inserire un indirizzo valido o selezionare un contatto dai suggerimenti</span>}
                </div>
            </div>

            <div className={classNames.inputWrapper}>
                <div className={props.sendMailFields.subject.touched && !props.sendMailFields.subject.valid ? 'field error' : 'field'}>
                    <Label className='field-label' htmlFor={props.sendMailFields.subject.internalName} required={props.sendMailFields.subject.required}>{props.sendMailFields.subject.displayName}</Label>

                    <TextField
                        key={props.sendMailFields.subject.internalName}
                        value={props.sendMailFields.subject.internalValue}
                        onChange={(event, newValue) => onChangeTextFieldValue({ ...props.sendMailFields.subject }, newValue)}
                    />
                    {props.sendMailFields.subject.touched && !props.sendMailFields.subject.valid && <span className="error-message">Campo obbligatorio</span>}
                </div>
            </div>

            <div className={classNames.inputWrapper}>
                <div className={props.sendMailFields.body.touched && !props.sendMailFields.body.valid ? 'field error' : 'field'}>
                    <Label className='field-label' htmlFor={props.sendMailFields.body.internalName} required={props.sendMailFields.body.required}>{props.sendMailFields.body.displayName}</Label>

                    <div style={{height: 300 }}>
                        <div ref={quillRef} />

                    </div>


                    {props.sendMailFields.body.touched && !props.sendMailFields.body.valid && <span className="error-message">Campo obbligatorio</span>}
                </div>
            </div>


        </React.Fragment>

    );
};

export default SendMailForm;





